import { getPath } from '@/router/common'

const baseUrl = {
  title: '企业微信',
  path: 'weCom'
}

export default [
  {
    path: getPath('weCom', baseUrl),
    name: 'weCom',
    component: () => import(/* webpackChunkName: "BillingJump" */ '@/views/weCom/weCom/index.vue'),
    meta: {
      title: 'weCom'
    }
  }
]
